export function formatCurrency(value: number): string {
  return `$${value.toLocaleString('de-DE', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
}

export function formatValueWithNet(gross: number, net: number | undefined | null): string {
  if (net === undefined || net === null) return formatCurrency(gross);
  return `${formatCurrency(gross)} (Netto: ${formatCurrency(net)})`;
}
